module.exports = __webpack_public_path__ + "img/3_126.92b5acfa.png";